import store from '@/store';

const useAcvStore = () => store;

export default useAcvStore;
